// import { addLocaleData } from 'react-intl';
import enLang from "./entries/en-US";
import esLang from "./entries/es-ES";
import trLang from "./entries/tr-TR";
import nbLang from "./entries/nb-NO";
import skLang from "./entries/sk-SK";
import roLang from "./entries/ro-RO";
import cyLang from "./entries/cy-GB";
import frLang from "./entries/fr-FR";
import nlLang from "./entries/nl-NL";
import hrLang from "./entries/hr-HR";
import srLang from "./entries/sr-RS";
import bsLang from "./entries/bs-BA";
import slLang from "./entries/sl-SI";
import csLang from "./entries/cs-CZ";
import { SUPPORTED_LANGUAGES } from "../constants";
// import {createIntl, createIntlCache, RawIntlProvider} from 'react-intl'

// // This is optional but highly recommended
// // since it prevents memory leak
// const cache = createIntlCache()

// const intl = createIntl({
//   locale: 'fr-FR',
//   messages: {}
// }, cache)

const AppLocale = {
  en: enLang,
  es: esLang,
  tr: trLang,
  nb: nbLang,
  sk: skLang,
  ro: roLang,
  cy: cyLang,
  fr: frLang,
  nl: nlLang,
  hr: hrLang,
  sr: srLang,
  bs: bsLang,
  sl: slLang,
  cs: csLang,
};
// addLocaleData(AppLocale.en.data);
// addLocaleData(AppLocale.es.data);
// addLocaleData(AppLocale.enrtl.data);

export default AppLocale;

// export const preferredLangArr = [
//   { value: 'en-US', label: 'English' },
//   { value: 'tr-TR', label: 'Turkish' },
//   { value: 'ro-RO', label: 'Romanian' },
//   { value: 'cs-CZ', label: 'Czech' },
//   { value: 'nl-NL', label: 'Dutch' },
//   { value: 'fr-FR', label: 'French' },
//   { value: 'es-ES', label: 'Spanish' },
//   { value: 'pt-PT', label: 'Portuguese' },
// ];

const localeStorageKey = "locale_lang";

export const updateLocale = (locale) => {
  localStorage.setItem(localeStorageKey, locale);
  window.dispatchEvent(new Event("storage"));
};

export const getLocale = () => {
  return localStorage.getItem(localeStorageKey) || "en";
};

export const handleSupportedLanguages = (supportedLanguages) => {
  localStorage.setItem(
    "supported_languages",
    JSON.stringify(supportedLanguages)
  );
  // Fall back to English when the API sends a language this build doesn't support yet
  const language = SUPPORTED_LANGUAGES[supportedLanguages?.[0]] || SUPPORTED_LANGUAGES["en-US"];
  updateLocale(language.key);
};
